export default "__VITE_ASSET__BtOA2cR3__"